import { j as C } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: r = 20,
  height: s = 20,
  viewBox: t = "0 0 20 20",
  fill: o = "currentColor",
  ...n
}) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    width: r,
    height: s,
    viewBox: t,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M9.99999 1.66666C14.6023 1.66666 18.3333 5.39762 18.3333 10C18.3333 14.6023 14.6023 18.3333 9.99999 18.3333C5.39761 18.3333 1.66666 14.6023 1.66666 10C1.66666 5.39762 5.39761 1.66666 9.99999 1.66666ZM10.1331 13.3333C8.43691 13.3333 6.90984 14.0572 5.84396 15.213C6.98365 16.1228 8.42832 16.6667 9.99999 16.6667C11.6412 16.6667 13.1439 16.0736 14.3055 15.0901C13.2463 14.0062 11.7682 13.3333 10.1331 13.3333ZM9.99999 3.33333C6.31809 3.33333 3.33332 6.3181 3.33332 10C3.33332 11.5088 3.83457 12.9006 4.67963 14.0178C6.04698 12.5701 7.98452 11.6667 10.1331 11.6667C12.2034 11.6667 14.0777 12.5055 15.4348 13.8618C16.2105 12.7722 16.6667 11.4394 16.6667 10C16.6667 6.3181 13.6819 3.33333 9.99999 3.33333ZM9.99999 4.16666C11.8409 4.16666 13.3333 5.65905 13.3333 7.5C13.3333 9.34091 11.8409 10.8333 9.99999 10.8333C8.15904 10.8333 6.66666 9.34091 6.66666 7.5C6.66666 5.65905 8.15904 4.16666 9.99999 4.16666ZM9.99999 5.83333C9.07949 5.83333 8.33332 6.57952 8.33332 7.5C8.33332 8.4205 9.07949 9.16666 9.99999 9.16666C10.9205 9.16666 11.6667 8.4205 11.6667 7.5C11.6667 6.57952 10.9205 5.83333 9.99999 5.83333Z",
        fill: o
      }
    )
  }
);
export {
  l as default
};
